import * as React from 'react'
import { isValidEmail } from '@sales-center/common'
import { styles } from './useStyles'
import Link from '@mui/material/Link'

export const GridEmailLink: React.FC<{ value: any; dataTestId?: string }> = ({
  value: email,
  dataTestId,
}) => {
  return typeof email === 'string' && isValidEmail(email) ? (
    <Link href={`mailto:${email}`} sx={styles.link} data-test-id={dataTestId}>
      {email}
    </Link>
  ) : (
    <>{email}</>
  )
}
GridEmailLink.displayName = 'GridEmailLink'
